import React, { useState } from 'react';
import { IconButton, Tooltip } from "@mui/material";
import MUIDataTable from 'mui-datatables';
import { ConfirmDialog, Localizacion } from 'lib.front';
import DeleteIcon from '@mui/icons-material/Delete';


const options = {
    filter: false,
    selectableRows: 'none',
    expandableRowsHeader: false,
    pagination: true,
    elevation: 0,
    rowsPerPage: 5,
    rowsPerPageOptions: [5, 10, 15, 100],
    search: false,
    print: false,
    download: false,
    viewColumns: false,
    fixedHeader: false,
    selectToolbarPlacement: 'none',
    selectableRowsOnClick: false,
    textLabels: Localizacion.muiDataTables.ES,

};



const ProductoTiendaTable = ({
    data,
    listaProductos,
    handleEliminar
}) => {

    const columns = [
        {
            name: "shopCodProd",
            label: "Código Tienda",
            options: {
                display: true
            }
        },
        {
            name: "",
            label: "Denominación",
            options: {
                display: true,
                customBodyRender: (value, tableMeta) => {
                    const producto = listaProductos.find(prod => prod.codigoBarra == tableMeta.rowData[0]);
                    return producto ? producto.denominacion : '-';
                }
            }
        },
        {
            name: '',
            label: '',
            options: {
                filter: false,
                display: 'true',
                viewColumns: false,
                customBodyRender: (value, tableMeta, updateValue) => {
                    return (
                        <>
                            <Tooltip title="Eliminar">
                                <IconButton onClick={() => { setSelectCodTienda(tableMeta.rowData[0]); setOpenDialog(true) }} size="large">
                                    <DeleteIcon />
                                </IconButton>
                            </Tooltip>
                        </>
                    );
                }
            }
        }
    ];

    const [openDialog, setOpenDialog] = useState(false);
    const [selectCodTienda, setSelectCodTienda] = useState(null);

    function onConfirm() {
        if (selectCodTienda) {
            handleEliminar(selectCodTienda)
            setSelectCodTienda(null);
        }
    }

    return (
        <>
            <MUIDataTable
                options={options}
                columns={columns}
                data={data}
            />

            {
                //@ts-ignore
                <ConfirmDialog
                    titulo=""
                    onConfirm={onConfirm}
                    setOpen={setOpenDialog}
                    variant={'warning'}
                    open={openDialog}
                    confirmStyle={{
                        backgroundColor: '#ef5350',
                        color: 'white',
                        '&:hover': {
                            backgroundColor: '#b71c1c'
                        }
                    }}
                >
                    ¿Seguro que desea eliminar el código asociado?
                </ConfirmDialog>
            }

        </>
    );
};
export default ProductoTiendaTable